import { authAxios } from "services";

export const fetchAll = (page, searchParams = {}) => {
  const urlParams = new URLSearchParams();
  urlParams.append("page", page);

  Object.keys(searchParams).forEach((key) => {
    if (searchParams[key]) {
      urlParams.append(key, searchParams[key]);
    }
  });
  return authAxios().get(`/showrooms?${urlParams.toString()}`);
};

export const fetchOptions = () => authAxios().get(`/showrooms/options`);

export const create = (data) => authAxios().post(`/showrooms`, data);

export const fetchById = (id) => authAxios().get(`/showrooms/${id}`);

export const fetchSubscriptionById = (id) => authAxios().get(`/showrooms/${id}/subscription`);

export const deleteById = (id) => authAxios().delete(`/showrooms/${id}`);

export const updateById = (id, data) => authAxios().post(`/showrooms/${id}?_method=PUT`, data);
